import styled from '@emotion/styled'
import { ThemeProp } from '@/styles/theme.ts'

export const SIDEBAR_SIZE = {
  SMALL: '240px',
  MEDIUM: '262px',
  LARGE: '320px',
}

export const Nav = styled.nav(
  ({ theme }) => `
  display: flex;
  flex-grow: 0;
  flex-direction: column;
  background-color: ${theme.ds.ColorBaseGreyLevel5};
  position: relative;

  @media (min-width: 768px) {
    width: ${SIDEBAR_SIZE.SMALL};
  }

  @media (min-width: 1366px) {
    width: ${SIDEBAR_SIZE.MEDIUM};
  }

  @media (min-width: 1920px) {
    width: ${SIDEBAR_SIZE.LARGE};
  }

  @media (max-width: 768px) {
    position: fixed;
    width: 100%;
    z-index: 12;
  }
`
)

export const linkStyle = ({ theme }: ThemeProp) => `
  width: 100%;
  height: 48px;
  display: flex;
  text-decoration: none;
  color: ${theme.ds.ColorBaseWhite};
  padding: 0 ${theme.ds.Space2X};
  box-sizing: border-box;
  position: relative;
  align-items: center;
  justify-content: space-between;

  span {
    align-self: center;
    letter-spacing: 0px;
    opacity: 1;
    font-weight: 500;
  }

  :hover {
    background-color: #484848;
  }
`

const activeLinkStyle = ({ theme }: ThemeProp) => `
  background-color: #FFF0B6;
  color: ${theme.ds.ColorBaseGreyLevel4};

  :before {
    content: '';
    background-color: ${theme.ds.ColorBaseYellowLevel6};
    width: 8px;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
  }

  :hover {
    background-color: #FFF0B6;
  }
`

export const Content = styled.div(
  ({ theme }) => `
    @media (max-width: 768px) {
      position: absolute;
      top: 60px;
      left: 0;
      width: 100%;
      height: calc(100vh - 60px);
      background-color: ${theme.ds.ColorBaseGreyLevel5};
      z-index: 10;
      transition: transform 0.2s ease-out;
      transform: translate(-100%, 0);
      overflow: auto;

      ::-webkit-scrollbar {
        width: 0px;
      }

      &[data-opened='true'] {
        transform: translate(0, 0);
      }
    }

    a {
      ${linkStyle({ theme })}

      &[data-active='true'] {
        ${activeLinkStyle({ theme })}
      }
    }
  `
)
